/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'gear': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(8 8)" _fill="#03272E" fill-rule="nonzero"><path pid="0" d="M15.882 6.915l-.897-.318a.973.973 0 01-.553-1.336l.408-.859a1.683 1.683 0 00-2.242-2.242l-.859.41a.974.974 0 01-1.335-.555l-.319-.896a1.683 1.683 0 00-3.17 0l-.319.897a.974.974 0 01-1.335.553L4.4 2.16A1.683 1.683 0 002.16 4.402l.408.86a.974.974 0 01-.553 1.335l-.897.32a1.682 1.682 0 000 3.169l.897.319a.973.973 0 01.553 1.335l-.408.86a1.683 1.683 0 002.242 2.241l.859-.408a.973.973 0 011.335.553l.319.896a1.683 1.683 0 003.17 0l.319-.896a.973.973 0 011.335-.553l.86.408a1.683 1.683 0 002.241-2.242l-.408-.86a.973.973 0 01.553-1.334l.897-.32a1.682 1.682 0 000-3.17zM8.5 11.89a3.492 3.492 0 01-3.146-2.085 3.41 3.41 0 011.842-4.449 3.448 3.448 0 014.449 1.842 3.41 3.41 0 01-1.842 4.449 3.25 3.25 0 01-1.303.243z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/gear.js